export class CommonResourceKeys {
    public static readonly GUIDE_POPUP_TITLE = "popupTitleGuide";
    public static readonly HISTORY_POPUP_TITLE = "popupTitleHistory";
    public static readonly ANNOUNCEMENT_POPUP_TITLE = "popupAnnouncement";
    public static readonly REBET = "rebet";
    public static readonly START_NEW_ROUND = "startNewRound";
    public static readonly RESULT = "result";
    public static readonly LOCKING_BET = "lockingBet";
    public static readonly USER_STAKE_LEVEL_UPDATE = "userStakeLevelUpdate";
    public static readonly DISPLAY_MODE = "displayMode";
    public static readonly DISPLAY_MODE_FULL = "fullMode";
    public static readonly DISPLAY_MODE_COLLAPSE = "collapseMode";
}
